/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { MessageModule } from 'primeng/message';
import { CommonModule } from '@angular/common';

import { SignupUserFeatureRoutingModule } from './signup-user-feature-routing.module';
import {SignUpUserComponent} from "./sign-up-user/sign-up-user.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import {AuthModule} from "@irian-ro/auth-web-client";
import {ButtonModule} from "primeng/button";
import {MessagesModule} from "primeng/messages";

@NgModule({
  declarations: [SignUpUserComponent],
    imports: [MessageModule, 
        CommonModule,
        SignupUserFeatureRoutingModule,
        ReactiveFormsModule,
        TranslateModule,
        AuthModule,
        ButtonModule,
        MessagesModule,
        FormsModule
    
   ]
})
export class SignupUserFeatureModule {

}
